import { gql } from '@apollo/client';
export const GET_ACTIVE_TRIP = gql `
  query ListTrips($listTripsInput: ListTripsInput) {
    listTrips(listTripsInput: $listTripsInput) {
      items {
        clientName
        clientPhone
        comment
        cost
        type
        currency
        id
        paymentType
        status
        createdByDriver
        commentForDriver
        canReject
        plannedPickUpAt
        routePoints {
          role
          address
          googlePlaceId
          location {
            latitude
            longitude
          }
        }
      }
    }
  }
`;
export const GET_NEXT_TRIP = gql `
  query ListTrips($listTripsInput: ListTripsInput) {
    listTrips(listTripsInput: $listTripsInput) {
      items {
        id
        plannedPickUpAt
        canReject
        routePoints {
          role
          address
        }
      }
    }
  }
`;
export const NEW_TRIP_HAS_ALREADY_STARTED = gql `
  query ListTrips($listTripsInput: ListTripsInput) {
    listTrips(listTripsInput: $listTripsInput) {
      items {
        id
        plannedPickUpAt
        routePoints {
          role
          address
        }
      }
    }
  }
`;
export const TRIP_REQUEST_START = gql `
  mutation TripRequestStart($tripRequestStartInput: TripRequestStartInput!) {
    tripRequestStart(tripRequestStartInput: $tripRequestStartInput) {
      success
    }
  }
`;
export const TRIP_REQUEST_ARRIVE = gql `
  mutation TripRequestArrive($tripRequestId: Uuid!) {
    tripRequestArrive(tripRequestId: $tripRequestId) {
      success
    }
  }
`;
export const TRIP_REQUEST_ONBOARD = gql `
  mutation TripRequestOnboard($tripRequestId: Uuid!) {
    tripRequestOnboard(tripRequestId: $tripRequestId) {
      success
    }
  }
`;
export const TRIP_REQUEST_FINISH = gql `
  mutation TripRequestFinish($tripRequestId: Uuid!) {
    tripRequestFinish(tripRequestId: $tripRequestId) {
      success
    }
  }
`;
export const LIST_TRIP_STATIONS = gql `
  query ListTripStations($listTripStationsInput: ListTripStationsInput!) {
    listTripStations(listTripStationsInput: $listTripStationsInput) {
      items {
        id
        name
        driversCount
        address
      }
    }
  }
`;
export const SET_STATUS_WAITING_FOR_ORDER = gql `
  mutation SetStatusWaitingForOrder($setStatusWaitingForOrderInput: SetStatusWaitingForOrderInput!) {
    setStatusWaitingForOrder(setStatusWaitingForOrderInput: $setStatusWaitingForOrderInput) {
      success
    }
  }
`;
export const SET_STATUS_OFFLINE = gql `
  mutation SetStatusOffline {
    setStatusOffline {
      success
    }
  }
`;
export const CREATE_TRIP_REQUEST = gql `
  mutation CreateTripRequest($createTripRequestInput: CreateTripRequestInput!) {
    createTripRequest(createTripRequestInput: $createTripRequestInput) {
      success
    }
  }
`;
export const TRIPS_STATIONS_AUTOCOMPLETE = gql `
  query TripsStationsAutocomplete($tripsStationsAutocompleteInput: TripsStationsAutocompleteInput!) {
    tripsStationsAutocomplete(tripsStationsAutocompleteInput: $tripsStationsAutocompleteInput) {
      items {
        id
        name
        address
      }
    }
  }
`;
export const TRIPS_REQUEST_COMPLAINT = gql `
  mutation TripRequestComplaint($tripRequestComplaintInput: TripRequestComplaintInput!) {
    tripRequestComplaint(tripRequestComplaintInput: $tripRequestComplaintInput) {
      success
    }
  }
`;
export const REJECT_TRIP_REQUEST = gql `
  mutation RejectTripRequest($tripRequestId: Uuid!) {
    rejectTripRequest(tripRequestId: $tripRequestId) {
      success
    }
  }
`;
export const WAITING_PLANNED_LIST_TRIPS = gql `
  query ListPlannedTrips($listPlannedTripsInput: ListPlannedTripsInput) {
    listPlannedTrips(listPlannedTripsInput: $listPlannedTripsInput) {
      items {
        id
        plannedPickUpAt
        canReject
        routePoints {
          address
          role
        }
      }
    }
  }
`;
